module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$hydrowareSecurityJS.canDisplay_A('suppliers') == false) ? _c('div', [_c('hydroware-access-to-page-denied', {
    attrs: {
      "text": "Suppliers Management"
    }
  })], 1) : _c('div', {
    staticClass: "suppliers"
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "x_panel tile "
  }, [_c('div', {
    staticClass: "x_content pform"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "x_title"
  }, [_c('h2', [_c('b', [_vm._v("Supplier Management")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right m-b-0"
  }, [(_vm.isaddding && _vm.$hydrowareSecurityJS.canAdd_A('suppliers')) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "float": "right",
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.AddSupplier('addCompliance')
      }
    }
  }, [_vm._v("\n                     Add Supplier\n                   ")]) : _vm._e(), _vm._v(" "), (!_vm.isediting && !_vm.isaddding && _vm.$hydrowareSecurityJS.canAdd_A('suppliers')) ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addCompliancevit()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus",
    staticStyle: {
      "font-size": "10px",
      "color": "white"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("\n                       Add")])]) : _vm._e(), _vm._v(" "), ((_vm.isediting || _vm.isaddding)) ? _c('el-button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showCompliancevit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left",
    staticStyle: {
      "font-size": "16px",
      "color": "white"
    },
    attrs: {
      "data-v-3e75863c": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("\n                       Supplier List\n                     ")])]) : _vm._e(), _vm._v(" "), (_vm.isediting && _vm.$hydrowareSecurityJS.canEdit_A('suppliers')) ? _c('el-button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "float": "right",
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.UpdateSupplier('addCompliance')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Update Supplier")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])], 1), _vm._v(" "), (!_vm.isediting && !_vm.isaddding) ? _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "vue-tables-options"
    }
  }, [_c('v-client-table', {
    ref: "dragtable",
    attrs: {
      "data": _vm.Suppliers,
      "columns": _vm.compliance_columns,
      "options": _vm.optionstable
    },
    scopedSlots: _vm._u([{
      key: "FirstName",
      fn: function(props) {
        return [_vm._v("\n                     " + _vm._s(props.row.SupplierContacts[0].FirstName) + "\n\n                   ")]
      }
    }, {
      key: "CellNumber",
      fn: function(props) {
        return [_vm._v("\n                     " + _vm._s(props.row.SupplierContacts[0].CellNumber) + "\n\n                   ")]
      }
    }, {
      key: "PrimaryEmail",
      fn: function(props) {
        return [_vm._v("\n                     " + _vm._s(props.row.SupplierContacts[0].PrimaryEmail) + "\n\n                   ")]
      }
    }, {
      key: "Actions",
      fn: function(props) {
        return [_c('div', [_c('hydroware-viewOrEdit-button', {
          attrs: {
            "EV": _vm.$hydrowareSecurityJS.showViewOrEditOrNeitherButton_A('suppliers')
          },
          on: {
            "click": function($event) {
              return _vm.editcol(props)
            }
          }
        }), _vm._v(" "), (_vm.$hydrowareSecurityJS.canDelete_A('suppliers')) ? _c('hydroware-delete-button', {
          on: {
            "click": function($event) {
              return _vm.del(props)
            }
          }
        }) : _vm._e()], 1)]
      }
    }], null, false, 238196715)
  })], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.isediting || _vm.isaddding) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, [_c('el-form', {
    ref: "addCompliance",
    staticClass: "hydroware-editNoEdit",
    attrs: {
      "disabled": _vm.$hydrowareSecurityJS.disableDataEntry_A('suppliers', _vm.isAddingOrEditing),
      "model": _vm.supplier,
      "rules": _vm.rules,
      "label-position": _vm.labelPosition,
      "spellcheck": "false"
    }
  }, [_c('div', {
    staticClass: "pull-in",
    attrs: {
      "id": "logWizard"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs  nav-justified bg-muted"
  }, [_c('li', {
    staticClass: "active",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "fli"
    }
  }, [_c('a', {
    attrs: {
      "id": "f_tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        return _vm.showFtab()
      }
    }
  }, [_vm._v("\n                          Main Profile\n                          ")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "sli"
    }
  }, [_c('a', {
    attrs: {
      "id": "s_tab",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        return _vm.showStab()
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Contact Profile")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-sm-12 col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-lg-12 col-sm-12 col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "tab-content b-0 m-b-0"
  }, [_c('div', {
    staticClass: "tab-pane p-t-10  active in",
    attrs: {
      "id": "profile-tab-1"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-sm-12 col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-lg-6 col-sm-12 col-xs-12 col-md-6"
  }, [_c('fieldset', [_c('legend', {
    staticClass: "tab_txt_title"
  }, [_vm._v("Main Information")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-sm-12 col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company Name:",
      "prop": "CompanyName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.CompanyName),
      callback: function($$v) {
        _vm.$set(_vm.supplier, "CompanyName", $$v)
      },
      expression: "supplier.CompanyName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Web Address:",
      "prop": "Title"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.WebAddress),
      callback: function($$v) {
        _vm.$set(_vm.supplier, "WebAddress", $$v)
      },
      expression: "supplier.WebAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address:",
      "prop": "gender"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": 400
    },
    model: {
      value: (_vm.supplier.Address1),
      callback: function($$v) {
        _vm.$set(_vm.supplier, "Address1", $$v)
      },
      expression: "supplier.Address1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "City:",
      "prop": "Title"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.City),
      callback: function($$v) {
        _vm.$set(_vm.supplier, "City", $$v)
      },
      expression: "supplier.City"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "State:",
      "prop": "Title"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.State),
      callback: function($$v) {
        _vm.$set(_vm.supplier, "State", $$v)
      },
      expression: "supplier.State"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Zip Code:",
      "prop": "Title"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.ZipCode),
      callback: function($$v) {
        _vm.$set(_vm.supplier, "ZipCode", $$v)
      },
      expression: "supplier.ZipCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone number:",
      "prop": "MainNumber"
    }
  }, [_c('el-input', {
    directives: [{
      name: "hydromask",
      rawName: "v-hydromask",
      value: ('(###) ### ####'),
      expression: "'(###) ### ####'"
    }],
    attrs: {
      "type": "text",
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.MainNumber),
      callback: function($$v) {
        _vm.$set(_vm.supplier, "MainNumber", $$v)
      },
      expression: "supplier.MainNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Fax Number:",
      "prop": "Title"
    }
  }, [_c('el-input', {
    directives: [{
      name: "hydromask",
      rawName: "v-hydromask",
      value: ('(###) ### ####'),
      expression: "'(###) ### ####'"
    }],
    attrs: {
      "type": "text",
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.MainFaxNumber),
      callback: function($$v) {
        _vm.$set(_vm.supplier, "MainFaxNumber", $$v)
      },
      expression: "supplier.MainFaxNumber"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "1px solid #e5e5e5",
      "min-height": "32px",
      "margin-bottom": "16px"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left",
      "font-size": "21px",
      "color": "#ffffff",
      "padding-right": "10px"
    }
  }, [_vm._v("Payment Address")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "float": "left"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": function($event) {
        return _vm.CopyTo()
      }
    },
    model: {
      value: (_vm.copyToPayment),
      callback: function($$v) {
        _vm.copyToPayment = $$v
      },
      expression: "copyToPayment"
    }
  }, [_vm._v("Same as Main")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company Name:",
      "prop": "PaymentCompanyName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.PaymentCompanyName),
      callback: function($$v) {
        _vm.$set(_vm.supplier, "PaymentCompanyName", $$v)
      },
      expression: "supplier.PaymentCompanyName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address:",
      "prop": "gender"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": 400
    },
    model: {
      value: (_vm.supplier.PaymentAddress1),
      callback: function($$v) {
        _vm.$set(_vm.supplier, "PaymentAddress1", $$v)
      },
      expression: "supplier.PaymentAddress1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "City:",
      "prop": "Title"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.PaymentCity),
      callback: function($$v) {
        _vm.$set(_vm.supplier, "PaymentCity", $$v)
      },
      expression: "supplier.PaymentCity"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "State:",
      "prop": "PaymentState"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.PaymentState),
      callback: function($$v) {
        _vm.$set(_vm.supplier, "PaymentState", $$v)
      },
      expression: "supplier.PaymentState"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Zip Code:",
      "prop": "PaymentZipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.PaymentZipCode),
      callback: function($$v) {
        _vm.$set(_vm.supplier, "PaymentZipCode", $$v)
      },
      expression: "supplier.PaymentZipCode"
    }
  })], 1)], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane p-t-10  ",
    attrs: {
      "id": "profile-tab-2"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-sm-12 col-xs-12 col-md-12"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-sm-12 col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('fieldset', [_c('legend', {
    staticClass: "tab_txt_title"
  }, [_vm._v("Name & Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "First Name:",
      "prop": "SupplierContacts[0].FirstName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.SupplierContacts[0].FirstName),
      callback: function($$v) {
        _vm.$set(_vm.supplier.SupplierContacts[0], "FirstName", $$v)
      },
      expression: "supplier.SupplierContacts[0].FirstName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Last Name:",
      "prop": "SupplierContacts[0].LastName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.SupplierContacts[0].LastName),
      callback: function($$v) {
        _vm.$set(_vm.supplier.SupplierContacts[0], "LastName", $$v)
      },
      expression: "supplier.SupplierContacts[0].LastName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address:",
      "prop": "SupplierContacts[0].Address1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": 400
    },
    model: {
      value: (_vm.supplier.SupplierContacts[0].Address1),
      callback: function($$v) {
        _vm.$set(_vm.supplier.SupplierContacts[0], "Address1", $$v)
      },
      expression: "supplier.SupplierContacts[0].Address1"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "City:",
      "prop": "SupplierContacts[0].City"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.SupplierContacts[0].City),
      callback: function($$v) {
        _vm.$set(_vm.supplier.SupplierContacts[0], "City", $$v)
      },
      expression: "supplier.SupplierContacts[0].City"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "State:",
      "prop": "SupplierContacts[0].State"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.SupplierContacts[0].State),
      callback: function($$v) {
        _vm.$set(_vm.supplier.SupplierContacts[0], "State", $$v)
      },
      expression: "supplier.SupplierContacts[0].State"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Zip Code:",
      "prop": "SupplierContacts[0].ZipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.SupplierContacts[0].ZipCode),
      callback: function($$v) {
        _vm.$set(_vm.supplier.SupplierContacts[0], "ZipCode", $$v)
      },
      expression: "supplier.SupplierContacts[0].ZipCode"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('fieldset', [_c('legend', {
    staticClass: "tab_txt_title"
  }, [_vm._v("Contact Details")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cell Number:",
      "prop": "SupplierContacts[0].CellNumber"
    }
  }, [_c('el-input', {
    directives: [{
      name: "hydromask",
      rawName: "v-hydromask",
      value: ('(###) ### ####'),
      expression: "'(###) ### ####'"
    }],
    attrs: {
      "type": "text",
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.SupplierContacts[0].CellNumber),
      callback: function($$v) {
        _vm.$set(_vm.supplier.SupplierContacts[0], "CellNumber", $$v)
      },
      expression: "supplier.SupplierContacts[0].CellNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Home Number:",
      "prop": "SupplierContacts[0].HomeNumber"
    }
  }, [_c('el-input', {
    directives: [{
      name: "hydromask",
      rawName: "v-hydromask",
      value: ('(###) ### ####'),
      expression: "'(###) ### ####'"
    }],
    attrs: {
      "type": "text",
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.SupplierContacts[0].HomeNumber),
      callback: function($$v) {
        _vm.$set(_vm.supplier.SupplierContacts[0], "HomeNumber", $$v)
      },
      expression: "supplier.SupplierContacts[0].HomeNumber"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Primary Email:",
      "prop": "SupplierContacts[0].PrimaryEmail"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.SupplierContacts[0].PrimaryEmail),
      callback: function($$v) {
        _vm.$set(_vm.supplier.SupplierContacts[0], "PrimaryEmail", $$v)
      },
      expression: "supplier.SupplierContacts[0].PrimaryEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Alternative Email:",
      "prop": "SupplierContacts[0].AlternativeEmail"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 100
    },
    model: {
      value: (_vm.supplier.SupplierContacts[0].AlternativeEmail),
      callback: function($$v) {
        _vm.$set(_vm.supplier.SupplierContacts[0], "AlternativeEmail", $$v)
      },
      expression: "supplier.SupplierContacts[0].AlternativeEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Employee Notes:",
      "prop": "SupplierContacts[0].EmployeeNotes"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "maxlength": 400
    },
    model: {
      value: (_vm.supplier.SupplierContacts[0].EmployeeNotes),
      callback: function($$v) {
        _vm.$set(_vm.supplier.SupplierContacts[0], "EmployeeNotes", $$v)
      },
      expression: "supplier.SupplierContacts[0].EmployeeNotes"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Supplier Notes :",
      "prop": "SupplierContacts[0].SupplierNotes"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "maxlength": 400
    },
    model: {
      value: (_vm.supplier.SupplierContacts[0].SupplierNotes),
      callback: function($$v) {
        _vm.$set(_vm.supplier.SupplierContacts[0], "SupplierNotes", $$v)
      },
      expression: "supplier.SupplierContacts[0].SupplierNotes"
    }
  })], 1)], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4",
    staticStyle: {
      "padding-left": "10%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  })])]), _vm._v(" "), _c('hr')])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right m-b-0"
  }, [(!_vm.isediting && _vm.$hydrowareSecurityJS.canAdd_A('suppliers')) ? _c('button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "float": "right",
      "background-color": "#4DB3FF",
      "border-color": "#4DB3FF",
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.AddSupplier('addCompliance')
      }
    }
  }, [_vm._v("\n                           Add Supplier\n                         ")]) : _vm._e(), _vm._v(" "), ((_vm.isediting || _vm.isaddding)) ? _c('el-button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showCompliancevit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left",
    staticStyle: {
      "font-size": "16px",
      "color": "white"
    },
    attrs: {
      "data-v-3e75863c": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("\n                             Supplier List\n                           ")])]) : _vm._e(), _vm._v(" "), (_vm.isediting && _vm.$hydrowareSecurityJS.canEdit_A('suppliers')) ? _c('el-button', {
    staticClass: "btn btn-default btn-md",
    staticStyle: {
      "float": "right",
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.UpdateSupplier('addCompliance')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Update Supplier")])]) : _vm._e()], 1)], 1)]) : _vm._e()], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2940f1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Administration/suppliers.vue
// module id = 850
// module chunks = 1